
export const Boxing = [
    {
    "id": 15,
    "Title": "IES-2024-15",
    "ImageSource": "/Boxing/BoxingGloves/15.png",
    "Category": "Bag Gloves"
},
{
    "id": 16,
    "Title": "IES-2024-16",
    "ImageSource": "/Boxing/BoxingGloves/16.png",
    "Category": "Bag Gloves"
},
{
    "id": 17,
    "Title": "IES-2024-17",
    "ImageSource": "/Boxing/BoxingGloves/17.png",
    "Category": "Bag Gloves"
},
{
    "id": 18,
    "Title": "IES-2024-18",
    "ImageSource": "/Boxing/BoxingGloves/18.png",
    "Category": "Bag Gloves"
},
{
    "id": 19,
    "Title": "IES-2024-19",
    "ImageSource": "/Boxing/BoxingGloves/19.png",
    "Category": "Bag Gloves"
},
{
    "id": 20,
    "Title": "IES-2024-20",
    "ImageSource": "/Boxing/BoxingGloves/20.png",
    "Category": "Bag Gloves"
},
]